import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AlumniPage from "@/pages/AlumniPage";
import RegisterPage from "@/pages/RegisterPage";
import GaleriPage from "@/pages/GaleriPage";
import PPDBPage from "@/pages/PPDBPage";
import ProgramPage from "@/pages/ProgramPage";
import ProfilPage from "@/pages/ProfilPage";
import ArtikelPage from "@/pages/ArtikelPage";
import ArtikelDetailPage from "@/pages/ArtikelDetailPage";
import GalangDanaPage from "@/pages/GalangDanaPage";
import GalangDanaDetailPage from "@/pages/GalangDanaDetailPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/alumni" element={<AlumniPage />} />
                <Route path="/daftar" element={<RegisterPage />} />
                <Route path="/galeri" element={<GaleriPage />} />
                <Route path="/ppdb" element={<PPDBPage />} />
                <Route path="/program" element={<ProgramPage />} />
                <Route path="/profil" element={<ProfilPage />} />
                <Route path="/artikel" element={<ArtikelPage />} />
                <Route path="/artikel/:id" element={<ArtikelDetailPage />} />
                <Route path="/galang-dana" element={<GalangDanaPage />} />
                <Route path="/galang-dana/:id" element={<GalangDanaDetailPage />} />
                <Route path="/masuk" element={<LoginPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
